<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="false">
  <h1>{{ companyTopic.name }}</h1>
  <img [src]="companyTopic.icon" />
  <p [innerHTML]="companyTopic.desc"></p>
</ion-content>
